export default __webpack_public_path__ + "static/media/vision.b1e5ecd3.jpg";